<template>
	<m-main-layout>
		<el-form :model="searchForm" label-width="100px" inline>
			<el-button @click="$router.back()">返回</el-button>
			<el-form-item label="时间">
				<range-time class="y" v-model="searchForm.create_time" style="width: 300px;"></range-time>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="toSearch">搜索</el-button>
				<el-button type="info" @click="toReset">重置</el-button>
			</el-form-item>
		</el-form>
		<el-table border size="mini" :data="list" style="width: 100%">
			<el-table-column type="index" label="排序"></el-table-column>
			<el-table-column prop="company" label="公司名称">
				<template slot-scope="scope">
					<a :href="$config.webUrl + '/company/detail/'+scope.row.uid" target="_blank">{{scope.row.company}}</a>
				</template>
			</el-table-column>
			<el-table-column prop="counts" label="发标数" width="80px"></el-table-column>
		</el-table>
		<div class="padding-top-bottom-20 text-center">
			<el-pagination
				background
				layout="total,prev, pager, next"
				:page-size="searchForm.pageSize"
				:current-page.sync="searchForm.page"
				:total="totalCount"
				@current-change="pageChange">
			</el-pagination>
		</div>
	</m-main-layout>
</template>

<script>
export default {
	name: "company",
	data() {
		return {
			searchForm:{
				page:1,
				pageSize:20,
				orderBy:'click_count',
				sortBy:'desc',
				create_time:''
			},
			totalCount:0,
			list:[]
		}
	},
	created() {
		this.searchForm.create_time = this.$route.query.create_time ? this.$route.query.create_time : ''
	},
	mounted() {
		this.getList();
	},
	methods: {
		toSearch(){
			this.getList()
		},
		toReset(){
			this.searchForm.create_time = '';
			this.getList();
		},
		getList(){
			let _this = this;

			_this.$http.httpPost({
				url: '/SystemTotal/getCompanyBidsTotal',
				datas: this.searchForm,
				success: (res) => {
					_this.list = res.list;
					_this.totalCount = res.totalCount;
				}
			});
		},
		pageChange(page){
			this.page = page;
			this.getList();
		},
	}
}
</script>
